import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js';
import GM from './GlobalMethods.js';
import store from './store/index.js';
import vClickOutside from "click-outside-vue3";
import {VueReCaptcha} from 'vue-recaptcha-v3';
import { createMetaManager } from 'vue-meta';

const app = createApp(App)
app.config.productionTip = false;
app.use(router);
app.mixin(GM);
app.use(store);
app.use(vClickOutside);
app.use(VueReCaptcha);
app.use(createMetaManager());
app.mount('#app')
